/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { CommandSmall } from './CommandSmall';
import { Getter } from '@devexpress/dx-react-core';
import { getColumns } from '../common/columns';
import { currencyFormatterEmpty } from './colorFormat';

export const getRowId = (row: any) => row._id;

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function SalaryItemsTable({
  rows,
  removeItem,
  isRTL,
  words,
  height = 350,
}: any) {
  const col = getColumns({ isRTL, words });
  const [columns] = useState(
    [
      col.employee,
      { name: 'month', title: isRTL ? 'شهر' : 'Month' },
      { name: 'basicSalary', title: isRTL ? 'الراتب الاساسي' : 'Basic Salary' },
      { name: 'extraSalary', title: isRTL ? 'البدلات' : 'Allowances' },
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'total', title: isRTL ? 'المجموع' : 'Total' },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: col.employee.name, width: 200 },
    { columnName: 'month', width: 100 },
    { columnName: 'basicSalary', width: 150 },
    { columnName: 'extraSalary', width: 150 },
    { columnName: 'overtime', width: 100 },
    { columnName: 'bonos', width: 100 },
    { columnName: 'deduction', width: 100 },
    { columnName: 'total', width: 150 },
  ]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const id = deleted[0];
      removeItem(id);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };
  return (
    <Paper
      style={{
        maxHeight: height,
        overflow: 'auto',
        margin: 10,
        minHeight: height,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />
          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <DataTypeProvider
            for={[
              'overtime',
              'bonos',
              'deduction',
              'basicSalary',
              'extraSalary',
              'total',
            ]}
            formatterComponent={currencyFormatterEmpty}
          ></DataTypeProvider>
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <TableEditColumn
            showDeleteCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <Getter
            name="tableColumns"
            computed={({ tableColumns }) => {
              const result = [
                {
                  key: 'editCommand',
                  type: TableEditColumn.COLUMN_TYPE,
                  width: 120,
                },
                ...tableColumns.filter(
                  (c: any) => c.type !== TableEditColumn.COLUMN_TYPE
                ),
              ];
              return result;
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
